import { Control } from 'react-hook-form';

import { Field } from 'coreOld/components';
import { AlignText, InputType } from 'coreOld/enums';
import { Icon } from 'coreOld/elements';
import { InputsWrapper } from 'partsOld/elements';
import { IPricingForm } from 'partsOld/types';

import { InputWrapper, Sign } from '../pricingFormStyle';

const DEFAULT_MIN_QTY = 1;
const DEFAULT_MARGIN_DISCOUNT = 0;

interface IProps {
  control: Control<IPricingForm, object>;
  uom: string;
  removePrice?: (index: number) => void;
  index: number;
}

const PricingItemView = ({ control, index, removePrice, uom }: IProps) => {
  return (
    <InputsWrapper container spacing={1}>
      <InputWrapper item xs={2.8}>
        <Sign bold>≥</Sign>
        <Field
          type={InputType.TEXTFIELD}
          name={`priceItems.${index}.minQuantity`}
          inputProps={{
            control,
            defaultValue: index === 0 ? DEFAULT_MIN_QTY : '',
            textAlign: AlignText.RIGHT,
          }}
        />
      </InputWrapper>

      <InputWrapper item xs={2.8}>
        <Sign>{'<'}</Sign>
        <Field
          type={InputType.TEXTFIELD}
          name={`priceItems.${index}.maxQuantity`}
          inputProps={{
            control,
          }}
        />
      </InputWrapper>

      <InputWrapper item xs={3}>
        <Sign>{uom || '-'}</Sign>
        <Field
          type={InputType.TEXTFIELD}
          name={`priceItems.${index}.marginReduction`}
          inputProps={{
            control,
            defaultValue: DEFAULT_MARGIN_DISCOUNT,
            textAlign: AlignText.RIGHT,
          }}
        />
      </InputWrapper>

      <InputWrapper item xs={2.5}>
        <Field
          type={InputType.TEXTFIELD}
          name={`priceItems.${index}.discountIncrease`}
          inputProps={{
            control,
            defaultValue: DEFAULT_MARGIN_DISCOUNT,
            textAlign: AlignText.RIGHT,
          }}
        />
      </InputWrapper>

      <InputWrapper item xs={0.5}>
        <Icon name={Icon.CLEAR} onClick={() => removePrice(index)} />
      </InputWrapper>
    </InputsWrapper>
  );
};

export default PricingItemView;
